import { Invoice, InvoiceItem } from 'entities/Invoice';
import { User } from 'entities/User';
import { Warehouse } from 'entities/Warehouse';
import { StepData, stepsMapper } from 'features/Stepper';

export enum IssuePersonalInvoiceSteps {
  SELECT_USER = 'Select a User',
  SELECT_WAREHOUSE = 'Select a Warehouse',
  INVOICE_DATA = 'Invoice data',
  INVOICE_ITEMS = 'Invoice items',
  PREVIEW = 'Preview',
}

export const issuePersonalInvoiceSteps = stepsMapper([...Object.values(IssuePersonalInvoiceSteps)]);

export interface IssueInvoiceModalSchema {
  isOpened: boolean;
  steps: StepData[];
  selectedUser: Nullable<User>;
  selectedWarehouse: Nullable<Warehouse>;
  invoiceData: Nullable<Partial<Invoice>>;
  invoiceItems: InvoiceItem[];
}
